import React from 'react'
import PropTypes from 'prop-types'
import { WindowScroller, AutoSizer } from 'react-virtualized'

import SortableList from './Components/SortableList'
import SubOrderGroup from './Components/SubOrderGroup'
import SubOrderItem from './Components/SubOrderItem'
import SubOrderGroupFooter from './Components/SubOrderGroupFooter'
import SubOrderFooter from './Components/SubOrderFooter'
import SubOrderGroupPlaceholder from './Components/SubOrderGroupPlaceholder'
import SubOrderPlaceholder from './Components/SubOrderPlaceholder'

export default class Items extends React.PureComponent {

  static propTypes = {
    listData: PropTypes.array.isRequired,
    editing: PropTypes.bool.isRequired,
    onMoveItem: PropTypes.func.isRequired,
  }

  componentDidUpdate = () => this.SortableContainer.getWrappedInstance().List.recomputeRowHeights()

  SortableContainer

  renderRow = (rowProps) => {

    const {
      index,
      key,
      style,
    } = rowProps

    const {
      listData,
    } = this.props

    const {
      component,
      subOrderGroup,
      subOrderItem,
    } = listData[index]

    if (component === 'SubOrderGroup') {
      return (
        <div key={key} style={style}>
          <SubOrderGroup
            index={index}
            subOrderGroup={subOrderGroup}
          />
        </div>
      )
    }

    if (component === 'SubOrderItem') {
      return (
        <div key={key} style={style}>
          <SubOrderItem
            index={index}
            subOrderItem={subOrderItem}
          />
        </div>
      )
    }

    if (component === 'SubOrderGroupFooter') {
      return (
        <div key={key} style={style}>
          <SubOrderGroupFooter
            index={index}
            subOrderGroup={subOrderGroup}
          />
        </div>
      )
    }

    if (component === 'SubOrderFooter') {
      return (
        <div key={key} style={style}>
          <SubOrderFooter
            index={index}
          />
        </div>
      )
    }

    if (component === 'SubOrderGroupPlaceholder') {
      return (
        <div key={key} style={style}>
          <SubOrderGroupPlaceholder
            index={index}
            subOrderGroup={subOrderGroup}
          />
        </div>
      )
    }

    if (component === 'SubOrderPlaceholder') {
      return (
        <div key={key} style={style}>
          <SubOrderPlaceholder />
        </div>
      )
    }

  }

  render() {

    const {
      listData,
      editing,
      onMoveItem,
    } = this.props

    return (

      <div style={{ pointerEvents: editing ? 'all' : 'none' }}>

        <WindowScroller>

          {({ height, scrollTop }) => (

            <AutoSizer disableHeight>

              {({ width }) => (

                <SortableList
                  autoHeight
                  height={height}
                  width={width}
                  scrollTop={scrollTop}
                  lockAxis='y'
                  overscanRowCount={5}
                  useDragHandle
                  rowHeight={({ index }) => listData[index].height}
                  rowRenderer={this.renderRow}
                  rowCount={listData.length}
                  ref={ref => { this.SortableContainer = ref }}
                  useWindowAsScrollContainer
                  onSortEnd={onMoveItem}
                />

              )}

            </AutoSizer>

          )}

        </WindowScroller>

      </div>

    )

  }

}
